import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_CAPACIDADES, ROW_COUNT, API_ADMIN_FACTORES_PERSONALES } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { IFactoresPersonales } from "../../../entities/IFactoresPersonales";
import { ICapacidades } from "../../../entities/ICapacidades";
import { cParamsActiveOrderTitle, cParamsPageSize } from "../../../helpers/paramsHelper";

interface ICapacidadesProps {
  cbFactoresPersonales?: Array<IFactoresPersonales>;
  items?: Array<any>;
}

const Capacidades = ({ cbFactoresPersonales, items }: ICapacidadesProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboFp, setComboFp] = useState<Array<IFactoresPersonales>>(cbFactoresPersonales || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = cParamsPageSize(pageSize);
    let result =
      items !== undefined
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_CAPACIDADES}/getall?PAGINA=1&PAGINADO=10`, { Authorization: `Bearer ${token}` }, params)).result;
    params.PAGINADO = ROW_COUNT;
    let list = result.data;
    console.log(list);
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    const combo = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_FACTORES_PERSONALES}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)
    ).result.data;
    setComboFp(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = (filter: Partial<ICapacidades>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.TIPO_CAUSA = filter.ID_FACTORES?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_CAPACIDADES}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: ICapacidades, filters: any) => {
    console.log(value);

    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";
    value.ID_FACTORES = value.ID_FACTORES || 1;
    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_CAPACIDADES}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID_CAPACIDADES: "1",
              ID_FACTORES: 1,
              TIPO_CAUSA: "",
              ACTIVO: true,
              AUTOR: "",
              AUTOR_DISPLAY: "",
              EDITOR: "",
              EDITOR_DISPLAY: "",
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_FACTORES",
            value: comboFp.map((fp) => {
              return { text: fp.TITULO, value: fp.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"Capacidades"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Capacidades"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Capacidades;
